// extracted by mini-css-extract-plugin
export default {"number":"PageNumber_number__kAgBw","number-header":"PageNumber_number-header__LPRw3"};